import { EngineType, RATKApp } from "./ratk-app";


// how should we handle the engine type?
new RATKApp();